import React from 'react';

import { ErrorPage } from '../molecules/ErrorPages/ErrorPage';

type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error: Error | null;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <ErrorPage
            title="Something went wrong"
            description={
              <div>
                An unexpected error occurred. Please try refreshing the page. If this persists,{' '}
                <a className="text-blue-500 hover:underline" href="mailto:support@wexler.ai">
                  contact support
                </a>
                .
              </div>
            }
          />
        )
      );
    }
    return this.props.children;
  }
}
